"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerText = exports.RecommendedText = exports.Wrapper = exports.ProvidersWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.ProvidersWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 0 34px;
  box-sizing: border-box;
  flex-direction: column;
  row-gap: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  height: auto;
  margin-bottom: 24px;
`;
exports.Wrapper = styled_components_1.default.div `
  ${({ recommended }) => (0, styled_components_1.css) `
    ${recommended
    ? (0, styled_components_1.css) `
          background: linear-gradient(180deg, #3b97ff 0%, #1a87ff 100%);
          border-radius: 14px;
          width: 100%;
          border: 2px solid #3b97ff;
          box-sizing: content-box;
        `
    : (0, styled_components_1.css) `
          width: 100%;
        `}
  `}
`;
exports.RecommendedText = styled_components_1.default.div `
  color: white;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.32px;
  padding: 7px 15px 8px;
  text-align: left;
`;
exports.PartnerText = styled_components_1.default.div `
  text-align: left;
`;
//# sourceMappingURL=styled.js.map